const roles = [
  {
    icon: 'ri-user-line',
    title: 'Сотрудник',
    desc: 'Отвечает за выполнение действий и участие в собственном развитии.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Руководитель',
    desc: 'Помогает определить приоритеты, даёт обратную связь и создаёт возможности для практики.',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'HR / L&D',
    desc: 'Помогает организовать систему, инструменты и контроль.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Наставник',
    desc: 'Передаёт опыт и помогает развивать навыки в реальных ситуациях.',
  },
  {
    icon: 'ri-mic-line',
    title: 'Тренер / коуч',
    desc: 'Подключается там, где необходимы обучение, практика или индивидуальная работа.',
  },
];

export default function WhoResponsible() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Кто отвечает за ИПР
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          ИПР — ответственность не только HR
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5 mb-12">
          {roles.map((r, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 hover:border-teal-200 transition-colors">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${r.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 border border-teal-100 rounded-2xl p-6 md:p-8 text-center max-w-3xl mx-auto">
          <p className="text-base md:text-lg font-semibold text-gray-900 leading-relaxed">
            Если ИПР существует только в HR-системе и не используется руководителем и сотрудником, он быстро превращается в формальный документ.
          </p>
        </div>
      </div>
    </section>
  );
}